<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE TIPO DE EVENTOS - FOLLOWUP'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-6">
          <label>
            <small v-show="form.nome.required" class="text-danger">*</small> Evento:
          </label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Nome do Evento'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>

        <div class="col-md-6">
          <label for="permissionSelect">Tipo de Quadro:</label>
          <v-select multiple
                    v-model="form.tipoAcessoEvento.value"
                    :options="form.tipoAcessoEvento.options"
                    :reduce="option => option.value"
                    class="w-100"
                    label="name">
            <template v-slot:no-options>Nenhum Funcionário encontrado.</template>
          </v-select>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

import EventTypeModel from '@/shared/models/configurations/eventtypemodel.js'
import EventTypeForms from './eventtype-form.js'
import EventTypeRepository from '@/shared/http/repositories/configurations/eventtype.js'

export default {
  name: 'EventTypeAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: EventTypeModel,
      form: EventTypeForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onCreate () {
      loading.push()
      EventTypeRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      EventTypeRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/eventtype/components/add/eventtypeadd.vue